import React from 'react';
import { Loader2 } from 'lucide-react';

// Skeleton Card for Posts
export const PostCardSkeleton: React.FC = () => (
  <div className="bg-white dark:bg-gray-800 rounded-xl p-4 shadow-sm border border-gray-100 dark:border-gray-700 animate-pulse">
    <div className="flex items-start space-x-3 mb-3">
      <div className="w-10 h-10 bg-gray-200 dark:bg-gray-700 rounded-full"></div>
      <div className="flex-1">
        <div className="h-4 bg-gray-200 dark:bg-gray-700 rounded w-1/3 mb-2"></div>
        <div className="h-3 bg-gray-200 dark:bg-gray-700 rounded w-1/4"></div>
      </div>
    </div>
    <div className="space-y-2 mb-3">
      <div className="h-4 bg-gray-200 dark:bg-gray-700 rounded w-full"></div>
      <div className="h-4 bg-gray-200 dark:bg-gray-700 rounded w-full"></div>
      <div className="h-4 bg-gray-200 dark:bg-gray-700 rounded w-3/4"></div>
    </div>
    <div className="flex items-center justify-between">
      <div className="flex items-center space-x-3">
        <div className="h-8 bg-gray-200 dark:bg-gray-700 rounded-full w-16"></div>
        <div className="h-8 bg-gray-200 dark:bg-gray-700 rounded-full w-16"></div>
        <div className="h-8 bg-gray-200 dark:bg-gray-700 rounded-full w-16"></div>
      </div>
      <div className="h-6 bg-gray-200 dark:bg-gray-700 rounded-full w-6"></div>
    </div>
  </div>
);

// Skeleton Card for Products
export const ProductCardSkeleton: React.FC = () => (
  <div className="bg-white dark:bg-gray-800 rounded-xl p-4 shadow-sm border border-gray-100 dark:border-gray-700 animate-pulse">
    <div className="w-full h-32 bg-gray-200 dark:bg-gray-700 rounded-lg mb-3"></div>
    <div className="flex items-center justify-between mb-3">
      <div className="h-5 bg-gray-200 dark:bg-gray-700 rounded w-1/3"></div>
      <div className="h-5 bg-gray-200 dark:bg-gray-700 rounded w-1/4"></div>
    </div>
    <div className="space-y-2 mb-3">
      <div className="h-5 bg-gray-200 dark:bg-gray-700 rounded w-3/4"></div>
      <div className="h-4 bg-gray-200 dark:bg-gray-700 rounded w-full"></div>
      <div className="h-4 bg-gray-200 dark:bg-gray-700 rounded w-2/3"></div>
    </div>
    <div className="flex items-center justify-between">
      <div className="h-8 bg-gray-200 dark:bg-gray-700 rounded-lg w-1/2"></div>
      <div className="h-5 bg-gray-200 dark:bg-gray-700 rounded w-1/4"></div>
    </div>
  </div>
);

// Skeleton Card for Articles
export const ArticleCardSkeleton: React.FC = () => (
  <div className="bg-white dark:bg-gray-800 rounded-xl p-4 shadow-sm border border-gray-100 dark:border-gray-700 animate-pulse">
    <div className="w-full h-48 bg-gray-200 dark:bg-gray-700 rounded-lg mb-3"></div>
    <div className="flex items-center justify-between mb-3">
      <div className="h-5 bg-gray-200 dark:bg-gray-700 rounded w-1/3"></div>
      <div className="h-5 bg-gray-200 dark:bg-gray-700 rounded-full w-5"></div>
    </div>
    <div className="h-6 bg-gray-200 dark:bg-gray-700 rounded w-3/4 mb-2"></div>
    <div className="h-4 bg-gray-200 dark:bg-gray-700 rounded w-full mb-2"></div>
    <div className="h-4 bg-gray-200 dark:bg-gray-700 rounded w-5/6 mb-4"></div>
    <div className="flex items-center justify-between">
      <div className="flex items-center space-x-3">
        <div className="h-4 bg-gray-200 dark:bg-gray-700 rounded w-16"></div>
        <div className="h-4 bg-gray-200 dark:bg-gray-700 rounded w-16"></div>
      </div>
      <div className="h-4 bg-gray-200 dark:bg-gray-700 rounded w-4"></div>
    </div>
  </div>
);

// Skeleton Card for Expert Sessions
export const SessionCardSkeleton: React.FC = () => (
  <div className="bg-white dark:bg-gray-800 rounded-xl p-4 shadow-sm border border-gray-100 dark:border-gray-700 animate-pulse">
    <div className="flex items-center justify-between mb-3">
      <div className="h-5 bg-gray-200 dark:bg-gray-700 rounded-full w-1/4"></div>
      <div className="h-5 bg-gray-200 dark:bg-gray-700 rounded-full w-1/6"></div>
    </div>
    <div className="h-6 bg-gray-200 dark:bg-gray-700 rounded w-3/4 mb-2"></div>
    <div className="h-4 bg-gray-200 dark:bg-gray-700 rounded w-full mb-2"></div>
    <div className="h-4 bg-gray-200 dark:bg-gray-700 rounded w-5/6 mb-4"></div>
    <div className="flex items-center space-x-3 mb-4">
      <div className="h-4 bg-gray-200 dark:bg-gray-700 rounded w-1/4"></div>
      <div className="h-4 bg-gray-200 dark:bg-gray-700 rounded w-1/4"></div>
      <div className="h-4 bg-gray-200 dark:bg-gray-700 rounded w-1/4"></div>
    </div>
    <div className="flex items-center justify-between">
      <div className="flex items-center space-x-2">
        <div className="w-8 h-8 bg-gray-200 dark:bg-gray-700 rounded-full"></div>
        <div className="h-4 bg-gray-200 dark:bg-gray-700 rounded w-20"></div>
      </div>
      <div className="h-8 bg-gray-200 dark:bg-gray-700 rounded-lg w-1/3"></div>
    </div>
  </div>
);

// Skeleton for Profile
export const ProfileSkeleton: React.FC = () => (
  <div className="bg-white dark:bg-gray-800 rounded-xl p-6 shadow-sm border border-gray-100 dark:border-gray-700 animate-pulse">
    <div className="flex items-start space-x-6 mb-6">
      <div className="w-24 h-24 bg-gray-200 dark:bg-gray-700 rounded-full"></div>
      <div className="flex-1">
        <div className="h-8 bg-gray-200 dark:bg-gray-700 rounded w-1/3 mb-2"></div>
        <div className="h-4 bg-gray-200 dark:bg-gray-700 rounded w-1/4 mb-4"></div>
        <div className="flex flex-wrap gap-2">
          <div className="h-6 bg-gray-200 dark:bg-gray-700 rounded-full w-20"></div>
          <div className="h-6 bg-gray-200 dark:bg-gray-700 rounded-full w-24"></div>
        </div>
      </div>
    </div>
    <div className="h-5 bg-gray-200 dark:bg-gray-700 rounded w-1/4 mb-3"></div>
    <div className="space-y-2 mb-6">
      <div className="h-4 bg-gray-200 dark:bg-gray-700 rounded w-full"></div>
      <div className="h-4 bg-gray-200 dark:bg-gray-700 rounded w-full"></div>
      <div className="h-4 bg-gray-200 dark:bg-gray-700 rounded w-3/4"></div>
    </div>
    <div className="flex justify-end">
      <div className="h-10 bg-gray-200 dark:bg-gray-700 rounded-lg w-1/4"></div>
    </div>
  </div>
);

// Skeleton for Comments
export const CommentSkeleton: React.FC = () => (
  <div className="p-4 border border-gray-200 dark:border-gray-700 rounded-lg animate-pulse">
    <div className="flex items-start space-x-3">
      <div className="w-8 h-8 bg-gray-200 dark:bg-gray-700 rounded-full"></div>
      <div className="flex-1">
        <div className="flex items-center space-x-2 mb-2">
          <div className="h-4 bg-gray-200 dark:bg-gray-700 rounded w-1/4"></div>
          <div className="h-4 bg-gray-200 dark:bg-gray-700 rounded-full w-16"></div>
        </div>
        <div className="space-y-2">
          <div className="h-4 bg-gray-200 dark:bg-gray-700 rounded w-full"></div>
          <div className="h-4 bg-gray-200 dark:bg-gray-700 rounded w-5/6"></div>
        </div>
      </div>
    </div>
  </div>
);

// Loading Overlay
export const LoadingOverlay: React.FC<{
  isLoading: boolean;
  message?: string;
  transparent?: boolean;
}> = ({ isLoading, message = 'Loading...', transparent = false }) => {
  if (!isLoading) return null;

  return (
    <div className={`fixed inset-0 ${transparent ? 'bg-white/50 dark:bg-gray-900/50' : 'bg-white/80 dark:bg-gray-900/80'} backdrop-blur-sm flex items-center justify-center z-50`}>
      <div className="text-center p-6 rounded-xl">
        <Loader2 className="w-12 h-12 text-green-600 dark:text-green-400 animate-spin mx-auto mb-4" />
        <p className="text-lg font-medium text-gray-900 dark:text-gray-100">{message}</p>
      </div>
    </div>
  );
};

// Loading Button
export const LoadingButton: React.FC<{
  isLoading: boolean;
  loadingText?: string;
  children: React.ReactNode;
  onClick?: () => void;
  disabled?: boolean;
  variant?: 'primary' | 'secondary' | 'ghost' | 'success' | 'warning' | 'error';
  size?: 'sm' | 'md' | 'lg';
  className?: string;
  type?: 'button' | 'submit' | 'reset';
}> = ({
  isLoading,
  loadingText = 'Loading...',
  children,
  onClick,
  disabled = false,
  variant = 'primary',
  size = 'md',
  className = '',
  type = 'button'
}) => {
  const variantClasses = {
    primary: 'btn-primary',
    secondary: 'btn-secondary',
    ghost: 'btn-ghost',
    success: 'btn-success',
    warning: 'btn-warning',
    error: 'btn-error'
  };

  const sizeClasses = {
    sm: 'btn-sm',
    md: 'btn-md',
    lg: 'btn-lg'
  };

  return (
    <button
      type={type}
      onClick={onClick}
      disabled={isLoading || disabled}
      className={`${variantClasses[variant]} ${sizeClasses[size]} ${className}`}
    >
      {isLoading ? (
        <div className="flex items-center justify-center space-x-2">
          <Loader2 className="animate-spin" size={size === 'sm' ? 14 : size === 'md' ? 18 : 22} />
          <span>{loadingText}</span>
        </div>
      ) : (
        children
      )}
    </button>
  );
};

// Inline Loading Indicator
export const InlineLoading: React.FC<{
  message?: string;
  className?: string;
}> = ({ message = 'Loading...', className = '' }) => {
  return (
    <div className={`flex items-center space-x-2 text-gray-600 dark:text-gray-400 ${className}`}>
      <Loader2 className="animate-spin" size={16} />
      <span className="text-sm">{message}</span>
    </div>
  );
};

// Shimmer Text
export const ShimmerText: React.FC<{
  width?: string;
  height?: string;
  className?: string;
}> = ({ width = '100%', height = '1rem', className = '' }) => {
  return (
    <div 
      className={`bg-gray-200 dark:bg-gray-700 rounded loading-shimmer ${className}`}
      style={{ width, height }}
    />
  );
};

// Skeleton Grid
export const SkeletonGrid: React.FC<{
  count: number;
  columns?: number;
  type?: 'card' | 'post' | 'product' | 'article';
  className?: string;
}> = ({ count, columns = 3, type = 'card', className = '' }) => {
  const SkeletonComponent = () => {
    switch (type) {
      case 'post':
        return <PostCardSkeleton />;
      case 'product':
        return <ProductCardSkeleton />;
      case 'article':
        return <ArticleCardSkeleton />;
      default:
        return (
          <div className="bg-gray-100 dark:bg-gray-800 rounded-xl p-4 animate-pulse">
            <div className="h-24 bg-gray-200 dark:bg-gray-700 rounded mb-3"></div>
            <div className="h-4 bg-gray-200 dark:bg-gray-700 rounded w-3/4 mb-2"></div>
            <div className="h-4 bg-gray-200 dark:bg-gray-700 rounded w-1/2"></div>
          </div>
        );
    }
  };

  return (
    <div 
      className={`grid gap-4 ${className}`}
      style={{ gridTemplateColumns: `repeat(${columns}, minmax(0, 1fr))` }}
    >
      {Array.from({ length: count }).map((_, i) => (
        <SkeletonComponent key={i} />
      ))}
    </div>
  );
};